import React from 'react';
import cn from '@/utils/cn';
import SPAButton from '../shared/SPAButton';
import type { ListState } from './syncStates';

const DOTS: Record<ListState, string> = {
  in_sync: 'tw-bg-spa-success',
  not_delivered: 'tw-bg-spa-danger-solid',
  out_of_sync: 'tw-bg-spa-danger-solid',
};

interface FilterPillProps {
  active: boolean;
  children: React.ReactNode;
  onClick: () => void;
  tone?: ListState;
}

const FilterPill = ({ active, children, onClick, tone }: FilterPillProps) => (
  <SPAButton aria-pressed={active} variant={active ? 'outline' : 'secondary'} onClick={onClick}>
    {tone != null && <span aria-hidden="true" className={cn('tw-h-2 tw-w-2 tw-rounded-full', DOTS[tone])} />}
    {children}
  </SPAButton>
);

export default FilterPill;
